// test1552
(1552 && 0);
